import { render, staticRenderFns } from "./loginAccess.vue?vue&type=template&id=622b628a&scoped=true"
import script from "./loginAccess.vue?vue&type=script&lang=js"
export * from "./loginAccess.vue?vue&type=script&lang=js"
import style0 from "./loginAccess.vue?vue&type=style&index=0&id=622b628a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622b628a",
  null
  
)

export default component.exports